import { render, staticRenderFns } from "./TciSolution.vue?vue&type=template&id=606f60a3"
import script from "./TciSolution.vue?vue&type=script&lang=js"
export * from "./TciSolution.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports